import { render } from "./Chatbot.vue?vue&type=template&id=1aaf7999&scoped=true"
import script from "./Chatbot.vue?vue&type=script&lang=js"
export * from "./Chatbot.vue?vue&type=script&lang=js"

import "./Chatbot.vue?vue&type=style&index=0&id=1aaf7999&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aaf7999"]])

export default __exports__